module.exports = __webpack_public_path__ + "02_long_beige.fa9b4471.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/02_long_beige.png
// module id = ITJ2
// module chunks = 0